import { render, staticRenderFns } from "./DeviceStatusStats.vue?vue&type=template&id=b0afb0e6&scoped=true"
import script from "./DeviceStatusStats.vue?vue&type=script&lang=js"
export * from "./DeviceStatusStats.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatusStats.vue?vue&type=style&index=0&id=b0afb0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0afb0e6",
  null
  
)

export default component.exports